// Backend address from environment variable
export const BACKEND_ADDRESS = process.env.REACT_APP_BACKEND_ADDRESS || 'NOT_DEFINED';

// Frontend URL from environment variable
export const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL || 'NOT_DEFINED';

// Base starting point configuration
// Options: GUIDE_TAB, PDF
export const BASE_STARTING_POINT = process.env.REACT_APP_BASE_STARTING_POINT || 'GUIDE_TAB';

// Example texts for animated placeholder
export const exampleTexts = [
  "My name is Sarah Johnson, sarah.johnson@gmail.com, +1 (555) 123-4567, from Seattle, USA.\nI worked as a software engineer from 2018 to 2024, I have experience in React, Python, and cloud technologies. I hold a BS in Computer Science.",

  "My name is Marco Rossi, marco.rossi@email.com, +39 333 123 4567, from Rome, Italy.\nI worked as a taxi driver from 2015 to 2025, I have a driving license and can speak English and Romanian. I know the city very well.",

  "My name is Lisa Chen, lisa.chen@outlook.com, +44 20 7946 0958, from London, UK.\nI worked as a marketing manager from 2019 to 2024, I have experience in digital marketing, social media, and campaign management. I have an MBA in Marketing.",

  "My name is Ahmed Hassan, ahmed.hassan@yahoo.com, +971 50 123 4567, from Dubai, UAE.\nI worked as a chef from 2016 to 2024, I specialize in Mediterranean cuisine and have managed kitchen teams. I graduated from culinary school.",

  "My name is Emma Schmidt, emma.schmidt@web.de, +49 30 12345678, from Berlin, Germany.\nI worked as a nurse from 2017 to 2024, I have experience in emergency care and patient management. I am certified in advanced life support."
];
